import { Injectable } from '@angular/core';
import {FormControl, FormGroup, Validators} from '@angular/forms';
import {Question} from "../../model/question";

@Injectable({
  providedIn: 'root'
})

export class QuestionService{

  // toFormGroup(question: Question) {
  //   const group: any = {};
  //   question.answers.forEach((answer) => {
  //     group[question.id] = question.required
  //       ? new FormControl(answer.value || '', Validators.required)
  //       : new FormControl(answer.value || '');
  //   });
  //   return new FormGroup(group);
  // }

  // public getQuestionById(poolId:string, questionId:number){
  //   if(questionId == 1){
  //     return new Question(
  //       1,"<!----><!----><span _ngcontent-ng-c771479544='' class='fontSetting questionItem user-select-none' style='font-size: 14px;'>What gas in the atmosphere can cause inflight problems (chest, breathing-throat)?</span><div _ngcontent-ng-c771479544='' style='margin-top: 10px;' class='ng-star-inserted'><!----></div><!----><div _ngcontent-ng-c771479544='' class='clearfix'></div>",
  //       'It is the tip - explaining the question overall and it is may be very long text',
  //       2,
  //       null,
  //       true,
  //       [
  //         {
  //           option: "A_"+questionId,
  //           label: "Ozone",
  //           value: 0,
  //           isCorrect: false,
  //           isChecked: false,
  //           isDisabled: false,
  //           tip: null
  //         },
  //         {
  //           option: "B_"+questionId,
  //           label: "Carbon dioxide",
  //           value: 1,
  //           isCorrect: true,
  //           isChecked: false,
  //           isDisabled: false,
  //           tip: 'It is the tip - explaining the answer overall and it is may be very long text',
  //         },
  //         {
  //           option: "C_"+questionId,
  //           label: "Argon",
  //           value: 0,
  //           isCorrect: false,
  //           isChecked: false,
  //           isDisabled: false,
  //           tip: null
  //         },
  //         {
  //           option: "D_"+questionId,
  //           label: "Nitrogen",
  //           value: 0,
  //           isCorrect: false,
  //           isChecked: false,
  //           isDisabled: false,
  //           tip: null
  //         }
  //       ]);
  //   }
  //   if(questionId == 2){
  //     return new Question(
  //       2,"Who is on the picture? </br> <img class='img-thumbnail' src='https://upload.wikimedia.org/wikipedia/commons/4/40/Hamlet_William_Morris_Hunt.jpeg' alt='hamlet'>",
  //       'It is the tip - explaining the question overall and it is may be very long text',
  //       3,
  //       1,
  //       true,
  //       [
  //         {
  //           option: "A_"+questionId,
  //           label: "This is option A",
  //           value: 0,
  //           isCorrect: false,
  //           isChecked: false,
  //           isDisabled: false,
  //           tip: null
  //         },
  //         {
  //           option: "B_"+questionId,
  //           label: "This is option B",
  //           value: 1,
  //           isCorrect: true,
  //           isChecked: false,
  //           isDisabled: false,
  //           tip: 'It is the tip - explaining the answer overall and it is may be very long text',
  //         },
  //         {
  //           option: "C_"+questionId,
  //           label: "This is option C",
  //           value: 0,
  //           isCorrect: false,
  //           isChecked: false,
  //           isDisabled: false,
  //           tip: null
  //         },
  //         {
  //           option: "D_"+questionId,
  //           label: "This is option D",
  //           value: 0,
  //           isCorrect: false,
  //           isChecked: false,
  //           isDisabled: false,
  //           tip: null
  //         }
  //       ]);
  //   }
  //   return new Question(
  //     questionId," A high pressure that is weakening with altitude and turns into a low is called a:",
  //     (questionId == 5 ? 'It is the tip - explaining the question overall and it is may be very long text' : null),
  //     questionId+1,
  //     questionId-1,
  //     (questionId == 5),
  //     [
  //       {
  //         option: "A_"+questionId,
  //         label: "This is option A",
  //         value: 0,
  //         isCorrect: false,
  //         isChecked: (questionId == 7),
  //         isDisabled: false,
  //         tip: null
  //       },
  //       {
  //         option: "B_"+questionId,
  //         label: "This is option B",
  //         value: 1,
  //         isCorrect: true,
  //         isChecked: (questionId != 7 && questionId != 8 && questionId != 19 && questionId != 5),
  //         isDisabled: false,
  //         tip: '\n' +
  //           '\n' +
  //           'Refer to figure.\n' +
  //           'There are five types of anticyclone, warm, cold, temporary cold, ridges (or wedges) and blocking.\n' +
  //           '\n' +
  //           'We will now study Cold and Warm Anticyclones:\n' +
  //           '\n' +
  //           'Cold anticyclones form over continents in winter and over polar areas at any time, accompanied by strong inversions: in the clear air, pronounced frosts and very cold surface conditions result.\n' +
  //           '\n' +
  //           '    The cold Highs weaken with increasing altitude (may turn into a LOW).\n' +
  //           '    Isobaric surfaces bulge upwards at lower heights they bulge downwards at greater heights => in a high pressure area, the pressure surface will bulge upwards at low level. However, low temperature at altitude gives low pressure at altitude, and if this effect is large enough, the pressure surfaces will become level with altitude and then start to bulge downwards.\n' +
  //           '\n' +
  //           'Warm anticyclones (so called because of the warm, subsided air aloft) over land areas typically bring spells of settled and often warm weather. These Highs are often almost stationary - often referred to as permanent.\n' +
  //           '\n' +
  //           '    The warm Highs intensify with increasing altitude.\n' +
  //           '    Pressure surfaces (contours) are pushed up by high pressure and high temperature => Isobaric surfaces bulge upwards in all levels.\n' +
  //           '\n' +
  //           'Furthermore, isobaric surfaces bulging upwards => indicate High pressure and isobaric pressures bulging downwards indicate Low pressures. '
  //       },
  //       {
  //         option: "C_"+questionId,
  //         label: "This is option C",
  //         value: 0,
  //         isCorrect: false,
  //         isChecked: (questionId == 8),
  //         isDisabled: false,
  //         tip: null
  //       },
  //       {
  //         option: "D_"+questionId,
  //         label: "This is option D",
  //         value: 0,
  //         isCorrect: false,
  //         isChecked: (questionId == 19),
  //         isDisabled: false,
  //         tip: null
  //       }
  //     ]);
  // }
  // public getQuestionPoolById(poolId: string)
  // {
  //   return [
  //     {
  //       id: 1,
  //       title: "Here is question",
  //       answered: false,
  //       correctAnswer: true,
  //       correctAnswerVariant: 'B',
  //       correctAnswerLabel: 'This is variant B',
  //     },
  //     {
  //       id: 2,
  //       title: "Here is question",
  //       answered: false,
  //       correctAnswer: false,
  //       correctAnswerVariant: 'B',
  //       correctAnswerLabel: 'This is variant B',
  //     },
  //     {
  //       id: 3,
  //       title: "Here is question",
  //       answered: true,
  //       correctAnswer: true,
  //       correctAnswerVariant: 'B',
  //       correctAnswerLabel: 'This is variant B',
  //     },
  //     {
  //       id: 4,
  //       title: "Here is question",
  //       answered: true,
  //       correctAnswer: true,
  //       correctAnswerVariant: 'B',
  //       correctAnswerLabel: 'This is variant B',
  //     },
  //     {
  //       id: 5,
  //       title: "Here is question",
  //       answered: false,
  //       correctAnswer: false,
  //       correctAnswerVariant: 'B',
  //       correctAnswerLabel: 'This is variant B',
  //     },
  //     {
  //       id: 6,
  //       title: "Here is question",
  //       answered: true,
  //       correctAnswer: true,
  //       correctAnswerVariant: 'B',
  //       correctAnswerLabel: 'This is variant B',
  //     },
  //     {
  //       id: 7,
  //       title: "Here is question",
  //       answered: true,
  //       correctAnswer: false,
  //       correctAnswerVariant: 'B',
  //       correctAnswerLabel: 'This is variant B',
  //     },
  //     {
  //       id: 8,
  //       title: "Here is question",
  //       answered: true,
  //       correctAnswer: false,
  //       correctAnswerVariant: 'B',
  //       correctAnswerLabel: 'This is variant B',
  //     },
  //     {
  //       id: 9,
  //       title: "Here is question",
  //       answered: true,
  //       correctAnswer: true,
  //       correctAnswerVariant: 'B',
  //       correctAnswerLabel: 'This is variant B',
  //     },
  //     {
  //       id: 10,
  //       title: "Here is question",
  //       answered: true,
  //       correctAnswer: true,
  //       correctAnswerVariant: 'B',
  //       correctAnswerLabel: 'This is variant B',
  //     },
  //     {
  //       id: 11,
  //       title: "Here is question",
  //       answered: true,
  //       correctAnswer: true,
  //       correctAnswerVariant: 'B',
  //       correctAnswerLabel: 'This is variant B',
  //     },
  //     {
  //       id: 12,
  //       title: "Here is question",
  //       answered: true,
  //       correctAnswer: true,
  //       correctAnswerVariant: 'B',
  //       correctAnswerLabel: 'This is variant B',
  //     },
  //     {
  //       id: 13,
  //       title: "Here is question",
  //       answered: true,
  //       correctAnswer: true,
  //       correctAnswerVariant: 'B',
  //       correctAnswerLabel: 'This is variant B',
  //     },
  //     {
  //       id: 14,
  //       title: "Here is question",
  //       answered: true,
  //       correctAnswer: true,
  //       correctAnswerVariant: 'B',
  //       correctAnswerLabel: 'This is variant B',
  //     },
  //     {
  //       id: 15,
  //       title: "Here is question",
  //       answered: true,
  //       correctAnswer: true,
  //       correctAnswerVariant: 'B',
  //       correctAnswerLabel: 'This is variant B',
  //     },
  //     {
  //       id: 16,
  //       title: "Here is question",
  //       answered: true,
  //       correctAnswer: true,
  //       correctAnswerVariant: 'B',
  //       correctAnswerLabel: 'This is variant B',
  //     },
  //     {
  //       id: 17,
  //       title: "Here is question",
  //       answered: true,
  //       correctAnswer: true,
  //       correctAnswerVariant: 'B',
  //       correctAnswerLabel: 'This is variant B',
  //     },
  //     {
  //       id: 18,
  //       title: "Here is question",
  //       answered: true,
  //       correctAnswer: true,
  //       correctAnswerVariant: 'B',
  //       correctAnswerLabel: 'This is variant B',
  //     },
  //     {
  //       id: 19,
  //       title: "Here is question",
  //       answered: true,
  //       correctAnswer: false,
  //       correctAnswerVariant: 'B',
  //       correctAnswerLabel: 'This is variant B',
  //     },
  //     {
  //       id: 20,
  //       title: "Here is question",
  //       answered: true,
  //       correctAnswer: true,
  //       correctAnswerVariant: 'B',
  //       correctAnswerLabel: 'This is variant B',
  //     },
  //     {
  //       id: 21,
  //       title: "Here is question",
  //       answered: true,
  //       correctAnswer: true,
  //       correctAnswerVariant: 'B',
  //       correctAnswerLabel: 'This is variant B',
  //     }
  //   ];
  // }
  public sendExamAnswer(){

  }
}
